import React, { useState } from 'react';

import Image from '../Image';
import Container from '../interface/Container';
import {
  Content,
  PlaceholderImage,
  PlayButton,
  StyledIframe,
  StyledPlayIcon,
  Subtitle,
  Title,
  VideoWrapper,
} from './YouTubeEmbed.styles';

const YouTubeEmbed = ({ videoData }) => {
  const [isPlayingVideo, setIsPlayingVideo] = useState(false);
  const { mainTitle, subTitle, placeholderImage, embed } = videoData;
  const { youtube_id: youTubeId } = embed.data;

  if (!youTubeId) {
    return null;
  }

  return (
    <Container size="medium">
      <VideoWrapper>
        {!isPlayingVideo ? (
          <>
            <PlayButton onClick={() => setIsPlayingVideo(true)}>
              <StyledPlayIcon />
            </PlayButton>
            <Content>
              <Title>{mainTitle}</Title>
              {subTitle && <Subtitle>{subTitle}</Subtitle>}
            </Content>
            <PlaceholderImage>
              <Image image={placeholderImage[0]} lazyload={false} />
            </PlaceholderImage>
          </>
        ) : (
          <StyledIframe
            width="1080"
            height="605"
            src={`https://www.youtube.com/embed/${videoData.embed.data.youtube_id}?autoplay=1&mute=1`}
            frameBorder="0"
            allowFullScreen
          />
        )}
      </VideoWrapper>
    </Container>
  );
};

export default YouTubeEmbed;
